import React, { Component } from 'react';
import injectSheet from 'react-jss';
import styleCss from '../styles/common';

class MessageBar extends Component {
    render() {
        const { type, rightActionText, actionCallback, leftSideText, shown } = this.props;
        if (!shown) {
            return null;
        }
        const { hMessageBarCont, hMessageBarWarn, hMessageBarSpan, hMessageBarAction } = this.props.classes;
        const bgColorClass = (type === "warning") ? hMessageBarWarn : hMessageBarWarn;
        return (
            <div className={`${hMessageBarCont} ${bgColorClass}`}>
                <span className={`h-small ${hMessageBarSpan}`}>{leftSideText}</span>
                <span
                    className={`h-small ${hMessageBarSpan} ${hMessageBarAction}`}
                    onClick={this.props.actionCallback}>
                    {rightActionText}
                </span>
            </div>
        );
    }
}

export default injectSheet(styleCss)(MessageBar);